import { Component, Input } from '@angular/core';

import { IAtxTag } from '../interfaces';

@Component({
    selector: 'atx-tag',
    template: `<a href="{{ model?.href }}"
   class="badge badge-{{ model?.type }}">
    {{ model?.label }}
</a>
`,
    styles: [``],
})

export class AtxTagComponent {
    @Input() public readonly model: IAtxTag;
}
